import React from 'react'
import { VenueCardData } from '../data/venues'

interface VenueCardProps {
  venue?: VenueCardData
  style?: React.CSSProperties
}

/** Venue card; without `venue` it renders an empty placeholder of the same size while data loads. */
const VenueCard: React.FC<VenueCardProps> = ({ venue, style }) => {
  if (!venue) {
    return <div aria-hidden="true" className="v2-venue-card v2-venue-card--placeholder" style={style} />
  }

  return (
    <div className="v2-venue-card" style={style}>
      {venue.logoUrl && <img alt="" aria-hidden="true" className="v2-venue-card__logo" src={venue.logoUrl} loading="lazy" />}
      <div className="v2-venue-card__top">
        <span className="v2-venue-card__pulse" />
        {venue.stat && <span className="v2-venue-card__stat">{venue.stat}</span>}
      </div>
      <div className="v2-venue-card__body">
        <p className="v2-venue-card__name">{venue.name}</p>
        <p className="v2-venue-card__area">{venue.label}</p>
      </div>
    </div>
  )
}

export default VenueCard
